import Grid from "@material-ui/core/Grid";
import * as React from "react";

import Container from "./Container";
import CountChart from "./CountChart";
import DashboardFilter from "./DashboardFilter";
import HeatMap from "./HeatMap";
import LineChartComponent from "./LineChartComponent";
import PieChartCLVorChurn from "./PieChartCLVorChurn";
import PieChartCustomerSectorStatistics from "./PieChartCustomerSectorStatistics";
import PieChartNba from "./PieChartNba";
import StackedBarChart from "./StackedBarChart";

class Dashboard extends React.Component<{}> {
  public render() {
    return (
      <Container>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <DashboardFilter />
          </Grid>
          <Grid item={true} xs={12} md={6}>
            <PieChartCLVorChurn />
          </Grid>
          <Grid item={true} xs={12} md={6}>
            <CountChart />
          </Grid>
          <Grid item={true} md={12} lg={6}>
            <PieChartNba />
          </Grid>
          <Grid item={true} md={12} lg={6}>
            <PieChartCustomerSectorStatistics />
          </Grid>
          <Grid item={true} xs={12}>
            <StackedBarChart />
          </Grid>
          <Grid item={true} xs={12}>
            <LineChartComponent />
          </Grid>
          <Grid item={true} xs={12}>
            <HeatMap />
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.tsx